import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AngularEditorComponent, AngularEditorConfig } from '@kolkov/angular-editor';
import { EDITOR_INLINE_EDIT } from '../editor-config';
import { toasterMessages } from '@messages/*';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { AssessmentService } from '../../assessments/assessment.service';
import { DashboardService } from '../../dashboard.service';
import { LoaderService } from 'src/app/services/loader.service';
import { MatMenu } from '@angular/material/menu';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';
import { RegenerateQuestionDialogComponent } from 'src/app/components/regenerate-question-dialog/regenerate-question-dialog.component';
import { RegenerateFlowService } from 'src/app/services/regenerate-flow.service';

@Component({
  selector: 'app-mcqs-list',
  templateUrl: './mcqs-list.component.html',
  styleUrls: ['./mcqs-list.component.scss']
})
export class McqsListComponent implements OnInit {
  @Input() showCheckboxes = false;
  @Output() bulkActionDone = new EventEmitter<void>();
  @ViewChild('mcqAnsEdit') editor!: AngularEditorComponent;
  @ViewChild('mcqMenu') mcqMenu!: MatMenu;
  @ViewChild('selectedMenu') selectedMenu!: MatMenu;
  @ViewChild('questionEditor') questionEditor: any;
  @Input() mcqsInfo: any;
  @Output() removeSelectedMCQ = new EventEmitter<string>();
  @Output() selectedMulChoiceQuestion = new EventEmitter<any>();
  @Output() mcqScroll = new EventEmitter<string>();
  @Output() mcqCountChanged = new EventEmitter<number>();

  private subscriptions: Subscription[] = [];
  private assessmentId: string = '';
  private editAssessmentId: string = '';
  private selectedMcqUndoTimeout: any;
  errorMessage: string = '';
  genearateSuccess: boolean = false;
  displayText: string = 'Re-Generating Question...';
  undoSelectedItem: any = { message: 'Question has been selected', duration: 5 };
  menuItem: any = null;
  setMenuItem(item: any) {
    this.menuItem = item;
  }

  public angularEditorConfig: AngularEditorConfig = EDITOR_INLINE_EDIT;

  editorEditConfig = EDITOR_INLINE_EDIT;
  selectedOption: number = -1;
  selectedAnswerIdex: number = -1;

  constructor(
    private assessmentService: AssessmentService,
    private activatedRoute: ActivatedRoute,
    private dashboardService: DashboardService,
    private toastr: ToastrService,
    private loaderService: LoaderService,
    public dialog: MatDialog, // Use public for Angular DI
    private regenerateFlow: RegenerateFlowService
  ) {
    this.editAssessmentId = this.activatedRoute.snapshot.paramMap.get('id');
  }

  ngOnInit(): void {
    this.assessmentId = this.mcqsInfo.assessmentId || this.editAssessmentId;
    // Initialize _selected and expanded property for each question
    if (this.mcqsInfo?.questions) {
      this.mcqsInfo.questions.forEach(q => {
        if (q._selected === undefined) q._selected = false;
        if (q.expanded === undefined) q.expanded = false;
      });
    }
  }

  undoSelectDeletedQuestion(question) {
    question.deleted = false;
  }

  removeSelectedMcqQuestionCross(question): void {
    question.edit_clicked = false;
    if (question.selected) {
      return;
    }
    if (this.mcqsInfo.from === 'questionsList') {
      this.removeSelectedMCQ.emit(question._id);
      return;
    }
    question.deleted = true;
  }

  /** Add multiple choice question to assessment. */
  addMcqToAssessment(item): void {
    item.selected = true;
    item.edit_clicked = false;
    item.displayText = 'Adding question...';
    const data = {
      "status": "SELECTED",
      "assessmentId": this.assessmentId
    }
    this.subscriptions.push(
      this.assessmentService.selectOrUndoQuestionToAssessment(item._id, data).subscribe((res) => {
        item.displayText = '';
        const serverItem = (res as any) && (res as any)._id ? { ...item, ...(res as any), sourceQuestionId: item._id } : item;
        this.selectedMcqUndoTimeout = setTimeout(() => {
          serverItem.selected = false;
          serverItem.status = "SELECTED";
          this.selectedMulChoiceQuestion.emit(serverItem);
        }, this.undoSelectedItem.duration * 1000);
      }, (err) => {
        this.errorMessage = err?.error?.errors[0]?.error || 'Something went wrong please try again!';
        item.error = true;
        setTimeout(() => {
          item.selected = false;
          item.error = false;
        }, 3000);
      })
    );
  }

  /**Undo selected question. */
  undoSelectedIQuestion(item): void {
    clearTimeout(this.selectedMcqUndoTimeout);
    item.selected = true;
    item.displayText = 'The selected question is being undone...';
    const data = {
      "status": "GENERATED",
      "assessmentId": this.assessmentId
    }
    this.subscriptions.push(
      this.assessmentService.selectOrUndoQuestionToAssessment(item._id, data).subscribe((res) => {
        item.displayText = '';
        item.selected = false;
      }, (err) => {
        item.error = true;
        setTimeout(() => {
          item.selected = false;
          item.error = false;
        }, 3000);
      })
    );
  }

  /**Remove Selected question */
  removeSelectedQuestionWithOk(question) {
    question.displayText = 'Removing Question...';
    if (question.status === 'GENERATED') {
      this.dashboardService.deleteQuestion(question._id).subscribe((res) => {
        question.displayText = '';
        question.deleted = false;
        this.removeSelectedMCQ.emit(question);
      }, (err) => {
        question.error = true;
        setTimeout(() => {
          question.deleted = false;
          question.error = false;
        }, 3000);
      })
    } else {
      const data = {
        "status": "GENERATED",
        "assessmentId": this.assessmentId
      }
      this.subscriptions.push(
        this.assessmentService.selectOrUndoQuestionToAssessment(question._id, data).subscribe((res) => {
          question.displayText = '';
          question.deleted = false;
          this.removeSelectedMCQ.emit(question);
        }, (err) => {
          question.error = true;
          setTimeout(() => {
            question.deleted = false;
            question.error = false;
          }, 3000);
        })
      );
    }
  }

  onMcqScroll(): void {
    this.mcqScroll.emit();
  }

  onEditClick(item: any) {
    // Only one edit at a time
    this.mcqsInfo.questions.forEach(q => q.edit_clicked = false);
    item.edit_clicked = true;
    item.temp_questionText = this.formatQuestionText(item.questionText);
    item.temp_answer = this.formatQuestionText(item.answer);
    item.temp_answerIndex = this.getAnswerIndex(item);
    item.temp_options = [...item.options];
    // Keep a snapshot of enterpriseOptions as well to fully revert on cancel
    if (Array.isArray(item.enterpriseOptions)) {
      item.temp_enterpriseOptions = [...item.enterpriseOptions];
    }
    item.editingOptionIndex = -1; // No option in edit mode initially
    // Store original values for revert on error
    item._original_questionText = item.questionText;
    item._original_answer = item.answer;
    if (this.mcqMenu && this.mcqMenu.closed) {
      this.mcqMenu.closed.emit();
    }
    setTimeout(() => this.focusQuestionEditor(), 100);
  }

  onEditOption(item: any, optionIndex: number) {
    item.editingOptionIndex = optionIndex;
    item.temp_optionValue = this.formatQuestionText(item.options[optionIndex]);
  }

  onSaveOption(item: any, optionIndex: number) {
    const oldValue = item.options[optionIndex];
    item.options[optionIndex] = item.temp_optionValue;
    // If the edited option was the currently selected correct answer, keep it in sync
    if (item.temp_answerIndex === optionIndex) {
      item.temp_answer = item.options[optionIndex];
    }
    item.editingOptionIndex = -1;
  }

  onCancelOption(item: any) {
    item.editingOptionIndex = -1;
  }

  onPanelOpen(item) {
    item.expanded = true;
  }

  onPanelClose(item) {
    item.expanded = false;
    if (item?.edit_clicked) {
      item.edit_clicked = false;
    }
  }

  onEditCancelBtnClick(item: any) {
    item.edit_clicked = false;
    // Revert any unsaved changes in the edit session
    item.temp_questionText = this.formatQuestionText(item.questionText);
    item.temp_answer = this.formatQuestionText(item.answer);
    item.temp_answerIndex = this.getAnswerIndex(item);
    // Restore options back to the snapshot taken at edit start
    if (Array.isArray(item.temp_options)) {
      item.options = [...item.temp_options];
    }
    // Keep enterpriseOptions in sync if present
    if (Array.isArray(item.temp_enterpriseOptions)) {
      item.enterpriseOptions = [...item.temp_enterpriseOptions];
    }
    // Ensure no option remains in inline edit mode
    item.editingOptionIndex = -1;
  }

  editOptionClick(options, index): void {
    this.selectedOption = index;
    options.temp_optionText = options.options[index];
    this.focusEditor();
  }

  optionEditDone(question) {
    const oldValue = question.options[this.selectedOption];
    const newValue = question.temp_optionText;
    question.options[this.selectedOption] = newValue;
    question.enterpriseOptions[this.selectedOption] = newValue;
    // Keep the saved correct answer in sync if its text changed
    if (this.getAnswerIndex(question) === this.selectedOption) {
      question.answer = newValue;
      if (typeof question.temp_answerIndex === 'number') {
        question.temp_answerIndex = this.selectedOption;
      }
    }
    this.loaderService.show('Updating question options');
    const payload: any = {
      options: question.options,
      // Include answer to ensure backend remains consistent when correct option text changes
      answer: question.answer,
    };
    this.subscriptions.push(
      this.dashboardService.updateQuestion(payload, question._id).subscribe((response) => {
        const selectedIndex = this.mcqsInfo?.questions?.findIndex((x: any) => x._id === question._id);
        if (selectedIndex !== undefined && selectedIndex !== null && selectedIndex > -1) {
          const uiState = {
            _selected: this.mcqsInfo.questions[selectedIndex]._selected,
            expanded: this.mcqsInfo.questions[selectedIndex].expanded,
          };
          this.mcqsInfo.questions[selectedIndex] = { ...response, ...uiState };
        }
        this.loaderService.hide();
        this.toastr.success(toasterMessages.questionMCQUpdated, 'Question updated', { timeOut: 2500 });
        delete question.temp_optionText;
      }, err => {
        this.toastr.error(err?.error?.errors[0]?.error, 'Error', { timeOut: 2500 });
        this.loaderService.hide();
        // Rollback local changes on failure
        question.options[this.selectedOption] = oldValue;
        question.enterpriseOptions[this.selectedOption] = oldValue;
        if (question.answer === newValue) {
          question.answer = oldValue;
        }
        delete question.temp_optionText;
      })
    );
  }

  /** Update multiple choice question api request */
  onEditDone(item: any) {
    // If an option is currently being edited, apply it before saving the entire question
    if (item.editingOptionIndex > -1 && item.temp_optionValue !== undefined) {
      item.options[item.editingOptionIndex] = item.temp_optionValue;
      item.editingOptionIndex = -1;
    }
    item.questionText = item.temp_questionText;
    // Derive answer from index when present
    if (typeof item.temp_answerIndex === 'number' && item.temp_answerIndex > -1) {
      item.answer = item.options[item.temp_answerIndex];
    } else {
      item.answer = item.temp_answer;
    }
    // Optionally, update options if changed
    // item.options = [...item.temp_options];
    item.edit_clicked = false;
    // Call update API
    this.dashboardService.updateQuestion({
      questionText: item.questionText,
      answer: item.answer,
      options: item.options
    }, item._id).subscribe({
      next: (res) => {
        this.toastr.success('Question updated successfully!', 'Success', { timeOut: 2500 });
        // Replace existing item with server response to avoid any local/server mismatch
        const idx = this.mcqsInfo?.questions?.findIndex((q: any) => q._id === item._id);
        if (idx !== undefined && idx !== null && idx > -1) {
          const uiState = {
            _selected: this.mcqsInfo.questions[idx]._selected,
            expanded: this.mcqsInfo.questions[idx].expanded,
          };
          this.mcqsInfo.questions[idx] = { ...res, ...uiState };
        }
        if (this.mcqMenu && this.mcqMenu.closed) {
          this.mcqMenu.closed.emit();
        }
      },
      error: (err) => {
        // Revert to original values on error
        item.questionText = item._original_questionText;
        item.answer = item._original_answer;
        // Ensure editor also shows original text on next open
        item.temp_questionText = item._original_questionText;
        item.temp_answerIndex = this.getAnswerIndex(item);
        // Revert any option changes done during edit mode
        if (Array.isArray(item.temp_options)) {
          item.options = [...item.temp_options];
        }
        // Ensure edit-mode selection reflects original answer
        item.temp_answer = item._original_answer;
        item.edit_clicked = false;
        // Force replace array entry to trigger UI update in all cases
        const idx = this.mcqsInfo?.questions?.findIndex((q: any) => q._id === item._id);
        if (idx !== undefined && idx !== null && idx > -1) {
          const uiState = {
            _selected: this.mcqsInfo.questions[idx]._selected,
            expanded: this.mcqsInfo.questions[idx].expanded,
          };
          this.mcqsInfo.questions[idx] = { ...this.mcqsInfo.questions[idx], ...uiState, questionText: item._original_questionText, answer: item._original_answer, options: Array.isArray(item.temp_options) ? [...item.temp_options] : item.options };
        }
        this.toastr.error(err?.error?.errors[0]?.error || 'Failed to update question.', 'Error', { timeOut: 2500 });
      }
    });
  }

  getAnswerIndex(item: any): number {
    if (!item || !Array.isArray(item.options)) return -1;
    const idx = item.options.findIndex((opt: string) => opt === item.answer);
    return idx > -1 ? idx : -1;
  }

  // Removed old GET-based re-generate method; dialog uses POST with optional hints

  // Open regenerate dialog to collect optional instructions
  openRegenerateDialog(question: any): void {
    // Close the kebab menu immediately
    if (this.mcqMenu && this.mcqMenu.closed) {
      this.mcqMenu.closed.emit();
    }
    // Open dialog first; show loader only when they click Regenerate in dialog
    this.subscriptions.push(
      this.regenerateFlow.ask('MCQ', question.additionalPrompts || []).pipe(
      ).subscribe({
        next: (result: any) => {
          if (!result || result === 'cancel') { return; }
          question.regenerate = true;
          this.genearateSuccess = false;
          this.displayText = 'Re-Generating Question...';
          const headers = { 'skip-loader': 'true' };
          this.dashboardService.reGenerateQuestion(question._id, headers, result.additionalPrompts || []).subscribe({
            next: (response) => {
              const selectedIndex = this.mcqsInfo?.questions?.findIndex(x => x._id === question._id);
              this.displayText = 'Successfully Re-Generated Question';
              this.genearateSuccess = true;
              this.mcqsInfo.questions[selectedIndex] = response.question;
              question.regenerate = false;
              question.deleted = false;
              // transient highlight to indicate which item got regenerated
              const updated = this.mcqsInfo.questions[selectedIndex];
              if (updated) {
                updated._highlight = true;
                setTimeout(() => { updated._highlight = false; }, 4000);
              }
            },
            error: (err) => {
              this.genearateSuccess = false;
              question.regenerate = false;
              this.displayText = '';
              this.toastr.error(err?.error?.errors[0]?.error, 'Error', { timeOut: 2500 });
            }
          });
        },
        error: (err) => {
          // dialog error unlikely; ignore
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }

  focusEditor() {
    const editorIframe = this.editor.textArea.nativeElement;
    editorIframe.focus();
  }

  focusQuestionEditor() {
    if (this.questionEditor && this.questionEditor.textArea) {
      this.questionEditor.textArea.nativeElement.focus();
    }
  }

  onBulkDelete(): void {
    const selected = this.mcqsInfo?.questions?.filter(q => q._selected);
    if (!selected?.length) return;
    const ids = selected.map(q => q._id);
    const idSet = new Set(ids.map(String));
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'delete-dialog-container',
      data: {
        danger: true,
        messageBody: `Are you sure you want to delete ${selected.length} selected question(s)? This action cannot be undone.`
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'confirm') {
        this.dashboardService.deleteMultipleQuestions(ids).subscribe({
          next: (res) => {
            const skippedSet = new Set((res.skipped || []).map(String));
            const actuallyDeleted = ids.filter(id => !skippedSet.has(String(id)));
            this.mcqsInfo.questions = this.mcqsInfo.questions.filter(q => !actuallyDeleted.includes(String(q._id)));
            // Restore skipped questions and clear their selection
            this.mcqsInfo.questions.forEach(q => {
              if (skippedSet.has(String(q._id))) {
                q._selected = false;
              }
            });
            this.mcqsInfo.totalQuestions -= (res.deletedCount || actuallyDeleted.length);
            this.mcqCountChanged.emit(this.mcqsInfo.totalQuestions);
            this.bulkActionDone.emit(); // Hide checkboxes after bulk delete
            if (res && res.message) {
              this.toastr.info(res.message, 'Bulk Delete', { timeOut: 3500 });
            } else {
              this.toastr.success('Selected questions deleted successfully!', 'Success', { timeOut: 2500 });
            }
          },
          error: (err) => {
            this.toastr.error('Failed to delete selected questions.', 'Error', { timeOut: 2500 });
          }
        });
      }
    });
  }

  onDelete(item: any): void {
    this.removeSelectedMcqQuestionCross(item);
    if (this.mcqMenu && this.mcqMenu.closed) {
      this.mcqMenu.closed.emit();
    }
  }

  onDuplicate(item: any): void {
    // Integrate copy API (copy into assessment as GENERATED when assessmentId exists)
    const payload: any = { id: item._id };
    if (this.mcqsInfo?.category === 'PREVIOUSLYGENERATED') {
      // Library copy: do not attach to assessment; keep it in Previously Generated
      // (no assessmentId, no status)
    } else if (this.assessmentId) {
      // Generated section copy: keep in Generated for this assessment
      payload.assessmentId = this.assessmentId;
      payload.status = 'GENERATED';
    }
    this.dashboardService.CopyQuestion(payload).subscribe({
      next: (res) => {
        if (res && res._id) {
          this.mcqsInfo.questions.unshift(res); // Add to top
          this.mcqsInfo.totalQuestions += 1;
          this.mcqCountChanged.emit(this.mcqsInfo.totalQuestions);
          this.toastr.success('Question copied successfully!', 'Success', { timeOut: 2500 });
          if (this.mcqMenu && this.mcqMenu.closed) {
            this.mcqMenu.closed.emit(); // Close the menu
          }
        } else {
          this.toastr.error('Failed to copy question.', 'Error', { timeOut: 2500 });
        }
      },
      error: (err) => {
        this.toastr.error('Failed to copy question.', 'Error', { timeOut: 2500 });
        if (this.mcqMenu && this.mcqMenu.closed) {
          this.mcqMenu.closed.emit();
        }
      }
    });
  }

  onSelectChange(item: any, event: any) {
    item._selected = event.checked;
  }

  hasSelectedQuestions(): boolean {
    return this.mcqsInfo?.questions?.some(q => q._selected);
  }

  toggleExpand(item: any) {
    item.expanded = !item.expanded;
  }

  deselectQuestion(item) {
    // Move the question back to generated (update status and emit event if needed)
    item.status = 'GENERATED';
    item.selected = false;
    this.mcqCountChanged.emit(this.mcqsInfo.questions.length);
    // Optionally emit a custom event if parent needs to handle
  }

  confirmDeleteSelected(item) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'delete-dialog-container',
      data: {
        danger: true,
        messageBody: `Are you sure you want to delete this question? This action cannot be undone.`
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'confirm') {
        this.dashboardService.deleteQuestion(item._id).subscribe({
          next: () => {
            this.mcqsInfo.questions = this.mcqsInfo.questions.filter(q => q._id !== item._id);
            this.mcqsInfo.totalQuestions -= 1;
            this.mcqCountChanged.emit(this.mcqsInfo.totalQuestions);
            this.toastr.success('Question deleted successfully!', 'Success', { timeOut: 2500 });
            if (this.mcqMenu && this.mcqMenu.closed) {
              this.mcqMenu.closed.emit();
            }
          },
          error: (err) => {
            const msg = err?.error?.errors?.[0]?.error || 'Failed to delete question.';
            this.toastr.error(msg, 'Delete Error', { timeOut: 3000 });
            if (this.mcqMenu && this.mcqMenu.closed) {
              this.mcqMenu.closed.emit();
            }
          }
        });
      }
    });
  }

  formatQuestionText(text: string): string {
    if (!text) return '';
    let formatted = text;

    // Handle escaped newlines (common in JSON data)
    formatted = formatted.replace(/\\n/g, '\n');

    // 1. Handle Code Blocks: ```code``` -> <pre><code>code</code></pre>
    formatted = formatted.replace(/```[a-z]*\s*([\s\S]*?)```/g, (match, p1) => {
      const code = p1.trim();
      return `<div class="code-block-premium">${code}</div>`;
    });

    // 2. Format Headers (# or ##) -> Bold
    formatted = formatted.replace(/^#+\s*(.*)$/gm, '<b>$1</b>');

    // 3. Handle Markdown bold: **text** -> <b>text</b>
    formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');

    // 4. Handle Inline Code: `code` -> <code>code</code>
    formatted = formatted.replace(/`(.*?)`/g, '<code>$1</code>');

    // 5. Handle Bullet Points: "- " or "* " at start of line -> Bullet
    formatted = formatted.replace(/^\s*[\-\*]\s+/gm, '&bull; ');

    // 6. Handle Newlines: \n -> <br>
    formatted = formatted.replace(/\n/g, '<br>');

    return formatted;
  }
}
